import React from "react";
import { motion } from "framer-motion";
import "./local-expertise.css";
import LazyBackground from "../../Lazy/lazy-background";

const LocalExpertise = () => {
  // Animation variants for consistency
  const sectionVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2, delayChildren: 0.1 },
    },
  };

  const textVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { type: "spring", stiffness: 100 },
    },
  };

  const imageVariants = {
    hidden: { opacity: 0, x: 20 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { type: "spring", stiffness: 100, delay: 0.1 },
    },
  };

  return (
    <motion.section
      className="le-section"
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
          <LazyBackground
            src={`${process.env.PUBLIC_URL}/assets/background15.svg`}
            alt=""
            className="home-background home-background5"
            loading="lazy"
          />
          <LazyBackground
            src={`${process.env.PUBLIC_URL}/assets/background12.svg`}
            alt=""
            className="home-background home-background4"
            loading="lazy"
          />
      <div className="le-content-container">
        <motion.div className="le-text-content" variants={textVariants}>
          <h2>Local Expertise, Global Standards</h2>
          <p>
            Based in Nigeria, our counselors combine deep knowledge of local
            health challenges with global best practices in genetic care. You’ll
            receive guidance that’s both culturally relevant and scientifically
            sound.
          </p>
        </motion.div>

        <motion.div className="le-image-container" variants={imageVariants}>
          <img
            src={`${process.env.PUBLIC_URL}/assets/diverse-doctors1.svg`}
            alt="Team of diverse genetic counselors"
            className="le-image"
          />
        </motion.div>
      </div>
    </motion.section>
  );
};

export default LocalExpertise;